import { useGetByIdQuery, useSearchQuery, useInfiniteSearchQuery } from './default.query-service';

const model = 'recordings';
const defaultBody = {
  sort: 'created_at',
  asc: false,
  pageSize: 25
};

export const useSearchRecordings = useSearchQuery({
  model,
  defaultBody
});

export const useInfiniteRecordings = useInfiniteSearchQuery({
  model,
  defaultBody
});

export const useGetRecording = useGetByIdQuery({
  model
});
